import {LocalDateTime} from 'js-joda'
import {Decoder, field, number, object, string} from 'json-bouncer'
import {localDateTimeDecoder} from '../Data/DecodeHelper'

export interface InquiryProofCopy {
    readonly id: number
    readonly inquiryId: number
    readonly filename: string
    readonly created: LocalDateTime
}

export function inquiryProofCopyDecoder(): Decoder<InquiryProofCopy> {
    return object({
        id: field('id', number()),
        inquiryId: field('inquiryId', number()),
        filename: field('filename', string()),
        created: field('created', localDateTimeDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryProofCopy.ts